import Vue from 'vue'

export default {
}



// WEBPACK FOOTER //
// ./src/store/mutations.js